// Site languages (D-WEB-LANG-SCOPE, D-WEB-LANG-HI-PA): English at the root, Chinese under /zh/.
// Pure data and functions, no imports.

export type Locale = "en" | "zh"

export interface LocaleInfo {
  /** BCP 47 tag for hreflang. */
  hreflang: string
  /** `<html lang>` value. */
  htmlLang: string
  /** Open Graph locale. */
  ogLocale: string
  /** URL prefix without slashes, "" for the English root. */
  prefix: string
  /** Name of the language in that language (language switcher). */
  label: string
}

export const LOCALES: Record<Locale, LocaleInfo> = {
  en: { hreflang: "en-AU", htmlLang: "en", ogLocale: "en_AU", prefix: "", label: "English" },
  zh: { hreflang: "zh-Hans", htmlLang: "zh-Hans", ogLocale: "zh_CN", prefix: "zh", label: "中文" },
}

export const DEFAULT_LOCALE: Locale = "en"

const ZH_PREFIX = /^\/zh(?=\/|$)/

/** Locale of a URL pathname: `/zh` and `/zh/...` are Chinese, everything else English. */
export function localeOfPath(pathname: string): Locale {
  return ZH_PREFIX.test(pathname) ? "zh" : "en"
}

/** Pathname without its locale prefix; the Chinese home (`/zh`) maps to `/`. */
export function stripLocale(pathname: string): string {
  const stripped = pathname.replace(ZH_PREFIX, "")
  return stripped === "" ? "/" : stripped
}

/** Pathname of the same page in `locale`; the Chinese home is `/zh` (no trailing slash: the site serves drop-trailing-slash, so `/zh/` would redirect). */
export function localizePath(path: string, locale: Locale): string {
  const clean = stripLocale(path.startsWith("/") ? path : `/${path}`)
  if (locale === "en") return clean
  return clean === "/" ? "/zh" : `/zh${clean}`
}
